import { LineupPlayer } from '@collector/desktop-feature-lineups'
import { SportId } from '@collector/sportsapi-client-legacy'
import { SubParticipant } from '@collector/sportsapi-types'

import { transformBaseballSubParticipants } from '../Sports/Baseball/configuration/pitcherOrder'

export type SubParticipantsPostprocessor = (
  eventId: number,
  players: SubParticipant[],
) => Promise<LineupPlayer[]>

const postprocessors = new Map<SportId, SubParticipantsPostprocessor>([
  [SportId.Baseball, transformBaseballSubParticipants],
])

export function getSubParticipantsPostprocessor(
  sportId: number,
): SubParticipantsPostprocessor | undefined {
  return postprocessors.get(sportId)
}
